module.exports = __webpack_public_path__ + "img/register.a1499d19.png";